import { useNavigate } from 'react-router-dom'

import Box from '~/core/Box'
import Button from '~/core/Button'
import { ORDERS_PATH, QUOTES_PATH } from '~/redux-modules/preferences'

import { PLACEMENT, RETURN_TO_ORDERS, RETURN_TO_QUOTES } from './constants'
import styles from './styles.css'

interface ReturnButtonPropsType {
    isQuote: boolean
}

const ReturnButton = (props: ReturnButtonPropsType): JSX.Element => {
    const { isQuote } = props

    const navigate = useNavigate()

    let quoteOrder = 'order'
    let returnTo = RETURN_TO_ORDERS
    let path = ORDERS_PATH

    if (isQuote) {
        quoteOrder = 'quote'
        returnTo = RETURN_TO_QUOTES
        path = QUOTES_PATH
    }

    return (
        <Box className={styles.buttonReturnQuotes}>
            <Button
                name={`return-${quoteOrder}`}
                placement={PLACEMENT}
                data-test-target={`return-${quoteOrder}-button`}
                onClick={() => {
                    navigate(path)
                }}
            >
                {returnTo}
            </Button>
        </Box>
    )
}

export default ReturnButton
